import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { TextFormat, Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './product.reducer';

export const Product = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const productList = useAppSelector(state => state.product.entities);
  const loading = useAppSelector(state => state.product.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="product-heading" data-cy="ProductHeading">
        <Translate contentKey="crawlerBackendApp.product.home.title">Products</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.product.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/product/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.product.home.createLabel">Create new Product</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {productList && productList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.product.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('productStatus')}>
                  <Translate contentKey="crawlerBackendApp.product.productStatus">Product Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productStatus')} />
                </th>
                <th className="hand" onClick={sort('feedType')}>
                  <Translate contentKey="crawlerBackendApp.product.feedType">Feed Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('feedType')} />
                </th>
                <th className="hand" onClick={sort('feedInType')}>
                  <Translate contentKey="crawlerBackendApp.product.feedInType">Feed In Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('feedInType')} />
                </th>
                <th className="hand" onClick={sort('productType')}>
                  <Translate contentKey="crawlerBackendApp.product.productType">Product Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productType')} />
                </th>
                <th className="hand" onClick={sort('initialEstimatedYearlyQuantity')}>
                  <Translate contentKey="crawlerBackendApp.product.initialEstimatedYearlyQuantity">
                    Initial Estimated Yearly Quantity
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('initialEstimatedYearlyQuantity')} />
                </th>
                <th className="hand" onClick={sort('retrievedYearlyQuantityReading')}>
                  <Translate contentKey="crawlerBackendApp.product.retrievedYearlyQuantityReading">
                    Retrieved Yearly Quantity Reading
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('retrievedYearlyQuantityReading')} />
                </th>
                <th className="hand" onClick={sort('initialFixedAnnualPrice')}>
                  <Translate contentKey="crawlerBackendApp.product.initialFixedAnnualPrice">
                    Initial Fixed Annual Price
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('initialFixedAnnualPrice')} />
                </th>
                <th className="hand" onClick={sort('activeDate')}>
                  <Translate contentKey="crawlerBackendApp.product.activeDate">Active Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('activeDate')} />
                </th>
                <th className="hand" onClick={sort('inactiveDate')}>
                  <Translate contentKey="crawlerBackendApp.product.inactiveDate">Inactive Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('inactiveDate')} />
                </th>
                <th className="hand" onClick={sort('usage')}>
                  <Translate contentKey="crawlerBackendApp.product.usage">Usage</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('usage')} />
                </th>
                <th className="hand" onClick={sort('desireStartDate')}>
                  <Translate contentKey="crawlerBackendApp.product.desireStartDate">Desire Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('desireStartDate')} />
                </th>
                <th className="hand" onClick={sort('desireEndDate')}>
                  <Translate contentKey="crawlerBackendApp.product.desireEndDate">Desire End Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('desireEndDate')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.product.productOrder">Product Order</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.product.productOffering">Product Offering</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.product.ean">Ean</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {productList.map((product, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/product/${product.id}`} color="link" size="sm">
                      {product.id}
                    </Button>
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.ProductStatus.${product.productStatus}`} />
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.FeedType.${product.feedType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.FeedInType.${product.feedInType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`crawlerBackendApp.ProductType.${product.productType}`} />
                  </td>
                  <td>{product.initialEstimatedYearlyQuantity}</td>
                  <td>{product.retrievedYearlyQuantityReading}</td>
                  <td>{product.initialFixedAnnualPrice}</td>
                  <td>
                    {product.activeDate ? (
                      <TextFormat type="date" value={product.activeDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {product.inactiveDate ? (
                      <TextFormat type="date" value={product.inactiveDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{product.usage}</td>
                  <td>
                    {product.desireStartDate ? (
                      <TextFormat type="date" value={product.desireStartDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {product.desireEndDate ? (
                      <TextFormat type="date" value={product.desireEndDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {product.productOrder ? (
                      <Link to={`/product-order/${product.productOrder.id}`}>{product.productOrder.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {product.productOffering ? (
                      <Link to={`/product-offering/${product.productOffering.id}`}>{product.productOffering.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{product.ean ? <Link to={`/ean/${product.ean.id}`}>{product.ean.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/product/${product.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/product/${product.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/product/${product.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.product.home.notFound">No Products found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Product;
